import * as React from 'react';

import { Typography } from 'components';

const Timer = () => {
  const [seconds, setSeconds] = React.useState<number>(1200);
  React.useEffect(() => {
    const interval = setInterval(function () {
      setSeconds((seconds) => {
        if (seconds > 0) {
          return seconds - 1;
        } else {
          clearInterval(interval);
          return 0;
        }
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const renderTimer = (value: number) => {
    const min = parseInt(`${value / 60}`, 10);
    const sec = parseInt(`${value % 60}`, 10);

    const resultMin = min < 10 ? '0' + min : min;
    const resultSec = sec < 10 ? '0' + sec : sec;
    return `${resultMin}:${resultSec}`;
  };
  return (
    <Typography align="center" textColor="grey">
      {renderTimer(seconds)}
    </Typography>
  );
};

export default Timer;
